import React, { useId } from 'react'
import { Form } from 'react-bootstrap'

/**
 * A switch that explains itself. The old pattern put a bare toggle under a
 * "Status" label, which said nothing about what turning it off does.
 *
 * Also used for feature toggles that reveal more fields (the banner's
 * navigation link), hence `children` — revealed content sits below the row.
 */
const StatusSwitch = ({
  label,
  hint,
  checked,
  onChange,
  onLabel = 'Active',
  offLabel = 'Inactive',
  onTone = 'success',
  offTone = 'danger',
  id,
  children,
}) => {
  const generatedId = useId()
  const switchId = id || `switch-${generatedId}`

  return (
    <>
      <div className='app-modal__switch-row'>
        <div>
          <div className='app-modal__switch-title'>{label}</div>
          {hint && <div className='app-modal__switch-hint'>{hint}</div>}
        </div>
        <div className='app-modal__switch-control'>
          <span
            className={`badge badge-light-${checked ? onTone : offTone}`}
          >
            {checked ? onLabel : offLabel}
          </span>
          <Form.Check
            type='switch'
            id={switchId}
            className='form-check-solid'
            aria-label={label}
            checked={checked}
            onChange={(event) => onChange(event.target.checked)}
          />
        </div>
      </div>
      {children}
    </>
  )
}

export default StatusSwitch
